// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_dxs","cls2":"FullScreenPremiumModal-cls2_hfS FullScreenPremiumModal-cls1_dxs"};